import { ApPayees } from '@/features/ap_payees/index';
import { r2wc } from '@/wc/helper/render';

export const AddNewPayee = r2wc(ApPayees, {
  shadow: 'open',
});
